module.exports = __webpack_public_path__ + "static/media/23.ae309e8d.jpeg";